/**
 * @generated SignedSource<<112856930fa128017d38fefaeab720cf>>
 * @relayHash 25d0e10d688d30e93b8445b211278591
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 93cbefe71fefe31a319254ba4dbc6ddacf9e21160a8224fcef17c37ba27d7cf1

import type { ConcreteRequest } from 'relay-runtime';
export type useResultSupplierAdvancedSearchCQLQuery$variables = {
  after?: string | null;
  cql: string;
  first?: number | null;
};
export type useResultSupplierAdvancedSearchCQLQuery$data = {
  readonly search: {
    readonly nodes: ReadonlyArray<{
      readonly content: {
        readonly ancestors: ReadonlyArray<{
          readonly id: string | null;
          readonly links: {
            readonly webUi: string | null;
          } | null;
          readonly title: string | null;
        } | null> | null;
        readonly extensions: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
        readonly id: string | null;
        readonly space: {
          readonly id: string | null;
          readonly key: string | null;
          readonly links: {
            readonly webUi: string | null;
          } | null;
          readonly name: string | null;
          readonly status: string | null;
        } | null;
        readonly type: string | null;
      } | null;
      readonly entityType: string | null;
      readonly excerpt: string | null;
      readonly lastModified: string | null;
      readonly space: {
        readonly icon: {
          readonly path: string;
        } | null;
        readonly id: string | null;
        readonly name: string | null;
        readonly type: string | null;
      } | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    } | null;
  } | null;
};
export type useResultSupplierAdvancedSearchCQLQuery = {
  response: useResultSupplierAdvancedSearchCQLQuery$data;
  variables: useResultSupplierAdvancedSearchCQLQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cql"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "type"
},
v6 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "alias": "webUi",
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = [
  {
    "alias": "search",
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
      },
      {
        "kind": "Variable",
        "name": "cql",
        "variableName": "cql"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      }
    ],
    "concreteType": "ConfluenceSearchConnection",
    "kind": "LinkedField",
    "name": "confluence_search",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceSearchResponse",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "entityType"
          },
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "excerpt"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          },
          {
            "kind": "ScalarField",
            "name": "lastModified"
          },
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "ancestors",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/)
                ]
              },
              {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "status"
                  }
                ]
              },
              {
                "concreteType": "KeyValueHierarchyMap",
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v8/*: any*/),
              (v5/*: any*/),
              {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "path"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasNextPage"
          },
          {
            "kind": "ScalarField",
            "name": "endCursor"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useResultSupplierAdvancedSearchCQLQuery",
    "selections": (v9/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useResultSupplierAdvancedSearchCQLQuery",
    "selections": (v9/*: any*/)
  },
  "params": {
    "cacheID": "25d0e10d688d30e93b8445b211278591",
    "id": "93cbefe71fefe31a319254ba4dbc6ddacf9e21160a8224fcef17c37ba27d7cf1",
    "metadata": {},
    "name": "useResultSupplierAdvancedSearchCQLQuery",
    "operationKind": "query",
    "text": "query useResultSupplierAdvancedSearchCQLQuery($cql:String!,$first:Int,$after:String){search:confluence_search(cql:$cql,first:$first,after:$after){nodes{entityType,title,excerpt,url,lastModified,content{id,type,ancestors{id,title,links{webUi:webui}},space{id,key,name,links{webUi:webui},status},extensions{key,value}},space{id,name,type,icon{path}}},pageInfo{hasNextPage,endCursor}}}"
  }
};
})();

(node as any).hash = "67a35c51a1f67fc0a0672cfb84296594";

export default node;
